import React from "react";
import { Box } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

const HorizontalMobileNavigation = ({ items, containerSx = {} }) => {
  const location = useLocation();

  const defaultContainerSx = {
    display: "flex",
    gap: "8px",
    borderRadius: "8px",
    width: "100%",
    marginBottom: "20px",
    overflowX: "auto",
    padding: "8px 0",
    height: "max-content",
    scrollbarWidth: "none", // Firefox
    "&::-webkit-scrollbar": { display: "none" }, // Chrome/Safari
    "& > *": { flexShrink: 0, flexGrow: 1, minWidth: "120px" }
  };

  const defaultLinkSx = {
    textDecoration: "none",
    padding: "12px 16px",
    borderRadius: "16px",
    fontSize: "0.875rem",
    fontWeight: 500,
    textAlign: "center",
    transition: "all 0.2s ease",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    minWidth: "120px",
    whiteSpace: "nowrap",
    flexGrow: 1
  };

  return (
    <Box sx={{ ...defaultContainerSx, ...containerSx }}>
      {items.map((item) => {
        const isActive = location.pathname.includes(item.to);
        const linkSx = {
          ...defaultLinkSx,
          backgroundColor: isActive ? "#ffffff" : "rgba(255, 255, 255, 0.5)",
          color: isActive ? "#333333" : "#666666",
          ...item.linkSx
        };

        return (
          <Link
            key={item.to}
            to={item.to}
            style={linkSx}
          >
            {item.label}
          </Link>
        );
      })}
    </Box>
  );
};

export default HorizontalMobileNavigation; 